// eslint-disable-next-line no-restricted-imports
import { FillLayer } from 'mapbox-gl'

import { LayerBase } from '../../Base'

class Layer extends LayerBase<FillLayer> {
  buildLayer(): FillLayer {
    return {
      id: this.id,
      layout: {},
      paint: {
        'fill-color': 'rgba(0, 0, 0, 0)',
        'fill-outline-color': '#888',
      },
      source: this.source,
      type: 'fill',
    }
  }
}

export default Layer
